import { render, staticRenderFns } from "./EndpointThreatEventsTable.vue?vue&type=template&id=5db5af9a&"
import script from "./EndpointThreatEventsTable.vue?vue&type=script&lang=js&"
export * from "./EndpointThreatEventsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports